import React, { useEffect, useState } from "react";
import ModalCenter from "../../../../components/common/Modal/ModalCenter";
import InputTextSimple from "../../../../components/common/InputText/InputTextSimple";
import ButtonFluid from "../../../../components/common/buttons/ButtonFluid";
import ButtonOutline from "../../../../components/common/buttons/ButtonOutline";
import CheckBoxWithOutLabel from "../../../../components/common/checkbox/CheckboxWithoutLabel";
import ButtonOutlineFluid from "../../../../components/common/buttons/ButtonOutlineFluid";
import { API_ROUTES } from "../../../../constants/API_ROUTES";
import useAuth from "../../../../hooks/useAuth";
import HttpHelper from "../../../../helpers/Http/HttpHelper";
import { toast } from "react-toastify";
import { ROUTES } from "../../../../constants/Routes";
import { useNavigate } from "react-router-dom";
import InputNumbersSimple from "../../../../components/common/InputText/InputNumbersSimple";
import Swal from "sweetalert2";

const ItemProfileModal = ({
  zoneId = "",
  zoneItemId = "",
  p_targyNeve = "",
  p_villanyszerelo = "",
  p_konyhaszerelo = "",
  p_dubelArbeiten = "",
  p_volume = "",
  p_csomagolasiIdo = "",
  p_buborekcsomagolasiIdo = "",
  p_kicsomagolasiIdo = "",
  p_szetszerelesiIdo = "",
  p_osszeszerelesiIdo = "",
  refresh = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { getAuth, clearAuth } = useAuth();

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  //Item Name
  const [targyNeve, setTargyNeve] = useState(p_targyNeve);
  const [targyNeveError, setTargyNeveError] = useState("");
  //Electricians
  const [villanyszerelo, setVillanyszerelo] = useState(p_villanyszerelo);
  const [villanyszereloError, setVillanyszereloError] = useState("");
  //Kitchen Fitter
  const [konyhaszerelo, setKonyhaszerelo] = useState(p_konyhaszerelo);
  const [konyhaszereloError, setKonyhaszereloError] = useState(false);
  //Dübel Arbeiten
  const [dubelArbeiten, setDubelArbeiten] = useState(p_dubelArbeiten);
  const [dubelArbeitenError, setDubelArbeitenError] = useState(false);
  //Volumen
  const [volume, setVolume] = useState(p_volume);
  const [volumeError, setVolumeError] = useState("");
  //Csomagolási idő /fő
  const [csomagolasiIdo, setCsomagolasiIdo] = useState(p_csomagolasiIdo);
  const [csomagolasiIdoError, setCsomagolasiIdoError] = useState("");
  //Buborékcsomagolási idő /fő
  const [buborekcsomagolasiIdo, setBuborekcsomagolasiIdo] = useState(p_buborekcsomagolasiIdo);
  const [buborekcsomagolasiIdoError, setBuborekcsomagolasiIdoError] = useState("");

  //Kicsomagolási idő /fő
  const [kicsomagolasiIdo, setKicsomagolasiIdo] = useState(p_kicsomagolasiIdo);
  const [kicsomagolasiIdoError, setKicsomagolasiIdoError] = useState("");

  //Szétszerelési idő /fő
  const [szetszerelesiIdo, setSzetszerelesiIdo] = useState(p_szetszerelesiIdo);
  const [szetszerelesiIdoError, setSzetszerelesiIdoError] = useState("");

  //Összeszerelési idő /fő
  const [osszeszerelesiIdo, setOsszeszerelesiIdo] = useState(p_osszeszerelesiIdo);
  const [osszeszerelesiIdoError, setOsszeszerelesiIdoError] = useState("");

  const navigate = useNavigate();

  const reset = () => {
    setTargyNeve("");
    setVillanyszerelo(false);
    setKonyhaszerelo(false);
    setDubelArbeiten(false);
    setVolume(0);
    setCsomagolasiIdo(0);
    setBuborekcsomagolasiIdo(0);
    setKicsomagolasiIdo(0);
    setSzetszerelesiIdo(0);
    setOsszeszerelesiIdo(0);

    setTargyNeveError("");
    setVillanyszereloError("");
    setKonyhaszereloError("");
    setDubelArbeitenError("");
    setVolumeError("");
    setCsomagolasiIdoError("");
    setBuborekcsomagolasiIdoError("");
    setKicsomagolasiIdoError("");
    setSzetszerelesiIdoError("");
    setOsszeszerelesiIdoError("");
  };

  const resetErrors = () => {
    setTargyNeveError("");
    setVillanyszereloError("");
    setKonyhaszereloError("");
    setDubelArbeitenError("");
    setVolumeError("");
    setCsomagolasiIdoError("");
    setBuborekcsomagolasiIdoError("");
    setKicsomagolasiIdoError("");
    setSzetszerelesiIdoError("");
    setOsszeszerelesiIdoError("");
  };

  const updateItem = () => {
    resetErrors();

    HttpHelper.PutRequest({
      route: API_ROUTES.ZONE_ITEMS_EDIT,
      token: getAuth()?.bearerToken,
      id: zoneItemId,
      parameters: {
        targyNeve,
        villanyszerelo,
        konyhaszerelo,
        dubelArbeiten,
        volume,
        csomagolasiIdo,
        buborekcsomagolasiIdo,
        kicsomagolasiIdo,
        szetszerelesiIdo,
        osszeszerelesiIdo,
        zoneId,
      },
    })
      .then((res) => {
        if (res.status == 200) {
          // reset();
          console.log(res.data);
          refresh();
          toast.success("Zone Item successfully updated !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (res.status == 422) {
          const messages = res.message;
          console.log(res);
          for (const key in messages) {
            if (messages.hasOwnProperty(key) && Array.isArray(messages[key]) && messages[key].length > 0) {
              const errorMessage = messages[key][0];
              if (key === "targyNeve") {
                setTargyNeveError(errorMessage);
              } else if (key === "villanyszerelo") {
                setVillanyszereloError(errorMessage);
              } else if (key === "konyhaszerelo") {
                setKonyhaszereloError(errorMessage);
              } else if (key === "dubelArbeiten") {
                setDubelArbeiten(errorMessage);
              } else if (key === "volume") {
                setVolumeError(errorMessage);
              } else if (key === "csomagolasiIdo") {
                setCsomagolasiIdoError(errorMessage);
              } else if (key === "bubbleWrapping") {
                setBuborekcsomagolasiIdoError(errorMessage);
              } else if (key === "kicsomagolasiIdo") {
                setKicsomagolasiIdoError(errorMessage);
              } else if (key === "szetszerelesiIdo") {
                setSzetszerelesiIdoError(errorMessage);
              } else if (key === "osszeszerelesiIdo") {
                setOsszeszerelesiIdo(errorMessage);
              }
            }
          }
        } else if (res.status == 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("Unknown error !", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  useEffect(() => {
    setTargyNeve(p_targyNeve);
    setVillanyszerelo(p_villanyszerelo);
    setKonyhaszerelo(p_konyhaszerelo);
    setDubelArbeiten(p_dubelArbeiten);
    setVolume(p_volume);
    setCsomagolasiIdo(p_csomagolasiIdo);
    setBuborekcsomagolasiIdo(p_buborekcsomagolasiIdo);
    setKicsomagolasiIdo(p_kicsomagolasiIdo);
    setSzetszerelesiIdo(p_szetszerelesiIdo);
    setOsszeszerelesiIdo(p_osszeszerelesiIdo);
  }, [
    zoneId,
    zoneItemId,
    p_targyNeve,
    p_villanyszerelo,
    p_konyhaszerelo,
    p_dubelArbeiten,
    p_volume,
    p_csomagolasiIdo,
    p_buborekcsomagolasiIdo,
    p_kicsomagolasiIdo,
    p_szetszerelesiIdo,
    p_osszeszerelesiIdo,
  ]);

  return (
    <>
      <ButtonFluid label={`Frissítés `} onClick={openModal} />

      <ModalCenter isOpen={isOpen} closeModal={closeModal} header={`Új tétel hozzáadása`}>
        <div className="w-full ">
          <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
            <label className="text-[1rem] w-[12rem]  font-lato font-normal leading-normal">Tárgy neve</label>
            <InputTextSimple
              placeholder={``}
              variant="light"
              value={targyNeve}
              error={targyNeveError}
              onChange={(e) => setTargyNeve(e.target.value)}
            />
          </div>
          <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
            <label className="text-[1rem] w-[12rem]  font-lato font-normal leading-normal">Villanyszerelő</label>
            <CheckBoxWithOutLabel
              value={villanyszerelo}
              checked={villanyszerelo}
              name={"villanyszerelo"}
              id={"villanyszerelo"}
              error={villanyszereloError}
              onClick={(e) => {
                console.log(e);
                setVillanyszerelo(!villanyszerelo);
              }}
            />
          </div>
          <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
            <label className="text-[1rem] w-[12rem]   font-lato font-normal leading-normal">Konyhaszerelő</label>
            <CheckBoxWithOutLabel
              checked={konyhaszerelo}
              value={konyhaszerelo}
              id={`konyhaszerelo`}
              name={`konyhaszerelo`}
              error={konyhaszereloError}
              onClick={(e) => {
                console.log(e);
                setKonyhaszerelo(!konyhaszerelo);
              }}
            />
          </div>
          <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
            <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">Dübel Arbeiten</label>
            <CheckBoxWithOutLabel
              checked={dubelArbeiten}
              value={dubelArbeiten}
              id={`dubelArbeiten`}
              name={`dubelArbeiten`}
              error={dubelArbeitenError}
              onClick={(e) => {
                setDubelArbeiten(!dubelArbeiten);
              }}
            />
          </div>

          <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
            <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">Volumen (m3)</label>
            <InputNumbersSimple
              placeholder={``}
              variant="light"
              id={"volume"}
              name={"volume"}
              value={volume}
              error={volumeError}
              onChange={(e) => setVolume(e.target.value)}
            />
          </div>
          <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
            <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">Csomagolási idő /fő</label>
            <InputNumbersSimple
              placeholder={``}
              variant="light"
              id={"csomagolasiIdo"}
              name={"csomagolasiIdo"}
              value={csomagolasiIdo}
              error={csomagolasiIdoError}
              onChange={(e) => setCsomagolasiIdo(e.target.value)}
            />
          </div>
          <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
            <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">
              Buborékcsomagolási idő /fő
            </label>
            <InputNumbersSimple
              placeholder={``}
              variant="light"
              id={"buborekcsomagolasiIdo"}
              name={"buborekcsomagolasiIdo"}
              value={buborekcsomagolasiIdo}
              error={buborekcsomagolasiIdoError}
              onChange={(e) => setBuborekcsomagolasiIdo(e.target.value)}
            />
          </div>
          <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
            <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">Kicsomagolási idő /fő</label>
            <InputNumbersSimple
              placeholder={``}
              variant="light"
              id={"kicsomagolasiIdo"}
              name={"kicsomagolasiIdo"}
              value={kicsomagolasiIdo}
              error={kicsomagolasiIdoError}
              onChange={(e) => setKicsomagolasiIdo(e.target.value)}
            />
          </div>
          <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
            <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">Szétszerelési idő /fő</label>
            <InputNumbersSimple
              placeholder={``}
              variant="light"
              id={"szetszerelesiIdo"}
              name={"szetszerelesiIdo"}
              value={szetszerelesiIdo}
              error={szetszerelesiIdoError}
              onChange={(e) => setSzetszerelesiIdo(e.target.value)}
            />
          </div>
          <div className="grid grid-cols-[200px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
            <label className="text-[1rem] w-[12rem] font-lato font-normal leading-normal">Összeszerelési idő /fő</label>
            <InputNumbersSimple
              placeholder={``}
              variant="light"
              id={"osszeszerelesiIdo"}
              name={"osszeszerelesiIdo"}
              value={osszeszerelesiIdo}
              error={osszeszerelesiIdoError}
              onChange={(e) => setOsszeszerelesiIdo(e.target.value)}
            />
          </div>
        </div>
        <div className="mt-12 ps-[230px] gap-5 flex flex-row  text-center">
          <ButtonOutlineFluid onClick={closeModal} label={`Elvetés`} />
          <ButtonFluid label={`Mentés`} onClick={updateItem} />
        </div>
      </ModalCenter>
    </>
  );
};

export default ItemProfileModal;
